export default __webpack_public_path__ + "static/media/template8.ce50c488.png";